export const keys = {
  share: 'share',
};
